<template>
  <div class="container">
    <common-card title="Preview Upload Orders" v-loading="loadingData">
      <div class="excel-errors" v-if="errors.length > 0">
        <el-alert v-for="(error, index) in errors" :key="index" :title="error" type="error" :closable="false" />
      </div>
      <template v-slot:header-ops>
        <div class="header-ops">
          <el-button :disable="loadingData" size="small" plain type="primary" @click="checkContent">
            Check Content
          </el-button>
          <el-upload :disable="loadingData" ref="upload" action="" :auto-upload="false" accept=".xls,.xlsx"
            :multiple="false" :show-file-list="false" :on-change="selectFileCb">
            <el-button size="small" plain type="primary">
              Upload Excel
            </el-button>
          </el-upload>
        </div>
      </template>
      <basic-table row-key="riiOrderNo" :table-data="orderData" :table-headers="ScanOrderPreviewTableHeaders"
        :has-actions="false" :has-row-expand="true" :showPagination="true" :summary="true" :stripe="true"
        :check-expand="() => true">
        <template v-slot:row-expand="props">
          <div class="good-group-container">
            <div :key="index" v-for="(group, index) in props.row.goodGroups">
              <div class="bold-oswald" style="font-size: 16px;">{{ group.palletCount }} Pallets in group</div>
              <basic-table :table-data="{ records: group.products, total: group.products.length }"
                :table-headers="ScanOrderPreviewGoodGroupTableHeaders" :has-actions="false" :has-row-expand="false"
                :showPagination="false" :summary="false" :stripe="false" />
            </div>
          </div>
        </template>
      </basic-table>
    </common-card>
  </div>
</template>
<script>
import CommonCard from '@/components/common/CommonCard.vue'
import BasicTable from '@/components/common/BasicTable.vue'
import { parseExcel } from '@/core/utils/excel'
import {
  ScanOrderPreviewTableHeaders,
  processUploadScanOrders,
  ScanOrderPreviewGoodGroupTableHeaders,
  ScanOrderExcelHeaders,
  ScanOrder
} from '@/core/models/order'
import { queryAddress } from '@/api/address'
import { NoteWrapUp } from '@/core/models/note'
import { cloneDeep } from 'lodash'
import { FalseStatus } from '@/core/configs/types'
// import { queryAddress } from '@/api/address'
export default {
  name: 'ScanOrderUploadPreview',
  components: {
    CommonCard,
    BasicTable
  },
  data() {
    return {
      ScanOrderPreviewTableHeaders,
      ScanOrderPreviewGoodGroupTableHeaders,
      loadingData: false,
      rows: [],
      errors: []
    }
  },
  computed: {
    orderData() {
      return {
        records: this.rows,
        total: this.rows.length,
        size: 10,
        current: 1
      }
    }
  },
  methods: {
    prepareScanOrders() {
      if (this.errors.length > 0) return []
      const orders = this.rows.map(row => {
        let newRow = cloneDeep(row)
        newRow = NoteWrapUp(newRow)
        newRow.type = ScanOrder
        delete newRow.comment
        delete newRow.cubeOrderNo
        delete newRow.platform
        const { goodGroups, vcInfo, ...rest } = newRow
        return {
          order: rest,
          vcInfo,
          scanOrderGroups: goodGroups.map(group => {
            delete group.factoryNo
            group.hold = FalseStatus
            group.products.forEach(product => {
              delete product.address
              delete product.factoryNo
            })
            return group
          })
        }
      })
      return {
        type: ScanOrder,
        orders
      }
    },
    checkContent() {
    },
    checkGoodsGroup(cubeOrderNo, goodGroup) {
      const flag = goodGroup.products.filter(one => one.quantity < one.cartons).length > 0
      if (flag) {
        return [false, `row ${cubeOrderNo} has cartons which is larger than quantity`]
      }
      const palletCount = goodGroup.palletCount
      if (palletCount > 1) {
        // check multiple pallets and multiple cartons
        let flag = goodGroup.products.filter(one => one.quantity % one.cartons !== 0).length > 0
        if (flag) {
          return [false, `row ${cubeOrderNo} has multiple pallets, quantity must be divided by cartons`]
        }
        flag = goodGroup.products.filter(one => one.cartons % palletCount !== 0).length > 0
        if (flag) {
          return [false, `row ${cubeOrderNo} has multiple pallets, carton must be divided by palelt count`]
        }
      }
      if (palletCount === 1) {
        let flag = goodGroup.products.filter(one => one.perPackageQty * (one.cartons - 1) >= one.quantity).length > 0
        if (flag) {
          return [false, `row ${cubeOrderNo} has single pallets, 总件数和单箱件数不够满足每箱都有货`]
        }
        flag = goodGroup.products.filter(one => one.perPackageQty * one.cartons < one.quantity).length > 0
        if (flag) {
          return [false, `row ${cubeOrderNo} has single pallets, 箱数乘以单箱件数小于总件数`]
        }
      }
      return [true, '']
    },
    selectFileCb(file) {
      this.loadingData = true
      this.$set(this, 'errors', [])
      this.$set(this, 'rows', [])
      parseExcel(file, { headers: ScanOrderExcelHeaders }, async (res, errors) => {
        return new Promise((resolve, reject) => {
          if (errors.length > 0) reject(errors)
          else {
            const rows = processUploadScanOrders(res)
            // first check goodGroup
            if (rows.length > 20) {
              const errors = ['cannot support more than 20 ordres at one time']
              reject(errors)
              return
            }
            const errors = rows.map(row => {
              return row.goodGroups.map(group => this.checkGoodsGroup(row.cubeOrderNo, group)).filter(one => !one[0])
            }).reduce((acc, val) => acc.concat(val), [])
            if (errors.length > 0) {
              reject(errors)
              return
            }
            let addressCodes = rows.map(one => one.goodGroups.map(two => two.factoryNo)).reduce((acc, val) => acc.concat(val), [])
            addressCodes = [...new Set(addressCodes)]
            if (addressCodes.length > 0) {
              queryAddress({ codes: addressCodes }).then(res => {
                const addressMap = Object.fromEntries(res.records.map(one => ([one.code, one])))
                const newErrors = []
                rows.forEach(row => {
                  row.goodGroups.forEach(goodGroup => {
                    const code = goodGroup.factoryNo
                    if (code in addressMap) {
                      goodGroup.addressId = addressMap[code].id
                      goodGroup.products.forEach(one => {
                        one.address = addressMap[code]
                      })
                    } else {
                      newErrors.push(`factory code ${code} has no address found in system`)
                    }
                  })
                })
                if (newErrors.length > 0) reject(newErrors)
                else resolve(rows)
              })
            } else {
              resolve(rows)
            }
          }
        }).then(rows => {
          this.$set(this, 'rows', rows)
        }).catch(errors => {
          this.$set(this, 'errors', errors)
        }).finally(() => {
          this.loadingData = false
        })
      })
    }
  }
}
</script>
<style lang="scss">
.header-ops {
  display: flex;
  flex-direction: row;
  gap: 20px;
}

.excel-errors {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  gap: 10px;
}

.good-group-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 20px;

  .table-container {
    width: 80%
  }
}
</style>
